import styled from 'styled-components';

interface TagWithIconProps {
    color?: string;
    backgroundColor?: string;
}


export const CardContainer = styled.div`
    position: relative;
    border-radius: 1rem;
    padding: 2rem;
    background: #1c1c1c;
    color: white;
    overflow: hidden;
    z-index: 0;

    /* Glowing border */
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 1rem;
        padding: 2px; /* Thickness of border */
        background: radial-gradient(
            circle at var(--mouse-x, 50%) var(--mouse-y, 50%),
            #7f5af0,
            transparent 70%
        );
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        -webkit-mask-composite: xor;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 1;
    }

    &:hover::before {
        opacity: 1;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    align-items: start;

    button {
        font-size: 1rem;
        font-weight: 600;
        padding: 0.6rem 1.5rem;
        z-index: 11;
    }
`;

export const Title = styled.h2`
    font-size: 1.8rem;
    font-weight: 700;
    color: white;
    margin-bottom: 10px;
    margin-top: 0;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.1), 0 0 20px rgba(255, 255, 255, 0.05);
`;

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

export const Tag = styled.span`
    background-color: rgba(255, 255, 255, 0.1);
    color: #ccc;
    font-size: 0.75rem;
    border-radius: 9px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: .6rem;
    height: 30px;
    padding: 0.3rem .6rem;
`;


export const TagWithIcon = styled.span<TagWithIconProps>`
    color: ${({ color }) => color || '#FFC107'};
    line-height: 1;
    border-radius: 9px;    
    svg {
        font-size: 1rem;
    }
`;

export const Description = styled.p`
    font-size: 0.95rem;
    color: #ddd;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const CTAButton = styled.a`
    align-self: flex-start;
    font-size: 1rem;
    padding: .8rem 2.5rem;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: linear-gradient(135deg, #612800, #3F51B5, #016c89, #000000);
    background-size: 200% 200%;
    background-position: left center;
    color: white;
    cursor: pointer;
    transition: background-position 0.5s ease, transform 0.3s ease;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);

    &:hover {
        background-position: right center;
        transform: scale(1.05);
    }

    .arrow {
        margin-left: 0.75rem;
        font-weight: bold;
    }
`;
